import axios from "axios";
import Vue from "vue";

let sessionId = window.name;

export default {
  state: () => ({
    isItChange: {},
    selectedTicketNumbers: {},
    isReservation: {},
    selectedUniquePassengersByIndex: {},
    openTicketUsageAllowed: {},
  }),
  mutations: {
    setIsItChange(state, isItChange) {
      Vue.set(state.isItChange, sessionId, isItChange);
    },
    setSelectedTicketNumbers(state, selectedTicketNumbers) {
      Vue.set(state.selectedTicketNumbers, sessionId, selectedTicketNumbers);
    },
    setIsReservation(state, isReservation) {
      Vue.set(state.isReservation, sessionId, isReservation);
    },
    setSelectedUniquePassengersByIndex(state, selectedUniquePassengersByIndex) {
      Vue.set(state.selectedUniquePassengersByIndex, sessionId, selectedUniquePassengersByIndex);
    },
    setDefaultBookingModule(state) {
      if (sessionId) {
        Vue.set(state.selectedTicketNumbers, sessionId, []);
        Vue.set(state.isReservation, sessionId, false);
        Vue.set(state.isItChange, sessionId, false);
        Vue.set(state.selectedUniquePassengersByIndex, sessionId, []);
        Vue.set(state.openTicketUsageAllowed, sessionId, false);
      } else {
        console.log("setDefaultBookingModule sessionId yok");
      }
    },
    resetBookingModule(state) {
      Vue.set(state, "selectedTicketNumbers", {});
      Vue.set(state, "isReservation", {});
      Vue.set(state, "isItChange", {});
      Vue.set(state, "selectedUniquePassengersByIndex", {});
      Vue.set(state, "openTicketUsageAllowed", {});
    },
    setOpenTicketUsageAllowed(state, openTicketUsageAllowed) {
      Vue.set(state.openTicketUsageAllowed, sessionId, openTicketUsageAllowed);
    },
  },
  actions: {
    ticketCancelPreparation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/ticket-cancellation-simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    getReservations: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/get-reservations", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    getReservationsSearch: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/reservations/search", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    ticketCancelPerform: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/ticket-cancellation-perform", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    organizationBasedTicketCancellationPerform: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/organization-based-ticket-cancellation-perform", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    erroneousOperationBasedTicketCancelPreparation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/erroneous-operation-based-ticket-cancellation-simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    erroneousOperationBasedTicketCancellationPerform: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/erroneous-operation-based-ticket-cancellation-perform", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    delayedTrainTicketCancellationPreparation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/delayed-train-ticket-cancellation-simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    delayedTrainTicketCancellationPerform: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/delayed-train-ticket-cancellation-perform", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    searchOpenTicket: (context, request) => {
      return axios.get(context.getters.getCrsServiceUrl + "/open-tickets/" + request.ticketNo).then((response) => {
        return response.data;
      });
    },
    createOpenTicket: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/open-tickets", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createOpenTicketSimulation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/open-tickets/simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    payCashCoupon: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/mcos/pay-back", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    ticketChangeValidation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/ticket-change-validation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    ticketChangeSimulation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/ticket-change-simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    ticketChangePerform: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/ticket-change-perform", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    ticketContactUpdate: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/ticket-contact-update", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    extendReservation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/extend-reservation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    extendReservationExact: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/extend-reservation-exact", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    checkMernis: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/verify/citizenship", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getFrontEndRestrictions: (context, request) => {
      return axios.get(context.getters.getPoolExternalUrl + "/pex/parameters/front-end-restrictions", request).then((response) => {
        return response;
      });
    },
    checkDisabledPerson: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/family-ministry/disabled-card-verify", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    institutionRefund: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/hts/train-passenger-list", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    institutionRefundV2: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/train-passenger-list", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    sendEmailForTicket: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/notifications/send-email-for-ticket", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    sendSMSForTicket: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/notifications/send-sms-for-ticket", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    reservationCancellation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/reservation-cancellation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    // Satış akışında ödeme -> koltuk seçimi geri dönüşünde ön rezervasyonu bırakmak için kullanılır.
    // Gerçek rezervasyon iptalinden (reservationCancellation) ayrı bir yetki tag'i ile korunuyor.
    preReservationCancellation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/pre-reservation-cancellation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    parametersByUnit: (context, request) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/parameters/by-unit/" + request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    checkMartyrVeteranPerson: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/family-ministry/martyr-veteran-verify", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    convertToCashRefundCoupon: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/mcos/open-ticket", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    splitReservationToTicketSimulation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/v2/reservation-to-ticket-simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getFrontEndRestrictionsByTrainType: (context, params) => {
      const queryParams = params.map((trainType) => `trainTypeEnums=${encodeURIComponent(trainType)}`).join("&");

      return axios.get(context.getters.getPoolExternalUrl + "/pex/parameters/front-end-restrictions?" + queryParams).then((response) => {
        return response;
      });
    },
    updatePassengersInReservation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/update-passengers", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    resendOTP: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/otp/resend", request)
        .then((response) => response)
        .catch((err) => err.response);
    },
    verifyOTP: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/otp/verify", request)
        .then((response) => response)
        .catch((err) => err.response);
    },
    deactiveOpenTicket: (context, request) => {
      return axios
        .put(context.getters.getCrsServiceUrl + "/open-tickets/deactivate", request)
        .then((response) => response)
        .catch((err) => err.response);
    },
    changeTicketStatus: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/hts/check-tickets-new", request, { headers: { "sales-channel": 3 } })
        .then((response) => response)
        .catch((err) => err.response);
    },
  },
  getters: {
    getIsItChange: (state) => state.isItChange[sessionId],
    getSelectedTicketNumbers: (state) => state.selectedTicketNumbers[sessionId],
    getIsReservation: (state) => state.isReservation[sessionId],
    getSelectedUniquePassengersByIndex: (state) => state.selectedUniquePassengersByIndex[sessionId],
    getOpenTicketUsageAllowed: (state) => state.openTicketUsageAllowed[sessionId],
  },
};
